import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { AlertTriangle, Check } from 'lucide-react';

export default function GridView({ badges, onSelectBadge, selectedIndex }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {badges.map((badgeData, index) => {
        const isSelected = index === selectedIndex;
        const hasOverflow = badgeData.isOverflowing;
        
        return (
          <Card
            key={index}
            onClick={() => onSelectBadge(index)}
            className={`card-playful p-4 cursor-pointer transition-all duration-200 ${
              isSelected 
                ? 'border-primary bg-primary/5 shadow-playful' 
                : 'border-border hover:border-primary/50'
            } ${
              hasOverflow ? 'ring-2 ring-destructive' : ''
            }`}
          >
            <div className="aspect-square bg-muted/30 rounded-xl overflow-hidden mb-2 relative">
              {badgeData.image ? (
                <img 
                  src={badgeData.image.url} 
                  alt={`Badge ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs">
                  No Image
                </div>
              )}
              
              {/* Status Indicators */}
              <div className="absolute top-2 right-2 flex gap-1">
                {hasOverflow && (
                  <Badge className="h-5 bg-destructive text-destructive-foreground">
                    <AlertTriangle className="w-3 h-3" />
                  </Badge>
                )}
                {badgeData.image && !hasOverflow && (
                  <Badge className="h-5 bg-success text-success-foreground">
                    <Check className="w-3 h-3" />
                  </Badge>
                )}
              </div>
            </div>
            
            <div className="text-center">
              <p className="text-sm font-medium mb-1">Badge {index + 1}</p>
              {badgeData.transform && (
                <p className="text-xs text-muted-foreground">
                  {Math.round(badgeData.transform.zoom * 100)}% zoom
                </p>
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
